export default __webpack_public_path__ + "static/media/researchgate.0df41f8a.svg";